document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.querySelector('input[name="quantity"]'); // real input
  const fakeQtyInput = document.querySelector('.fake-qty'); // for pm products
  const priceElement = document.querySelector('[data-product-price]');
  const calculatedPriceDisplay = document.getElementById("calculated-price");
  const isPerMeter = document.getElementById("is-per-meter")?.value === "1";

  if (!qtyInput || !priceElement || !calculatedPriceDisplay) return;

  // Parse price from span
  let pricePerUnit = parseFloat(
    priceElement.textContent.replace(/[^0-9.]/g, "")
  ) || 0;

  function updateTotal() {
    let realQty = isPerMeter ? parseFloat(qtyInput.value) || 2 : parseFloat(qtyInput.value) || 1;
    let qty = isPerMeter ? realQty : realQty;

    const total = pricePerUnit * qty;
    calculatedPriceDisplay.innerText = `₹${total.toFixed(2)}`;
  }

  // Update on real input change (non-pm and pm behind the scenes)
  qtyInput.addEventListener("input", updateTotal);
  qtyInput.addEventListener("change", updateTotal);
  qtyInput.addEventListener("blur", updateTotal);

  // If fake input exists (pm product), also track it
  if (fakeQtyInput) {
    fakeQtyInput.addEventListener("input", updateTotal);
    fakeQtyInput.addEventListener("change", updateTotal);
    fakeQtyInput.addEventListener("blur", updateTotal);
  }

  // Run once on load
  updateTotal();

  // Listen for variant changes to update price
  document.addEventListener('variant:update', function (event) {
    const { data } = event.detail;
    if (!data || !data.html) return;

    const newPriceContainer = data.html.querySelector('[data-product-price]');
    if (newPriceContainer) {
      // Update the hidden price element
      const currentPriceElement = document.querySelector('[data-product-price]');
      if (currentPriceElement) {
        currentPriceElement.textContent = newPriceContainer.textContent;
      }

      // Update the local variable
      pricePerUnit = parseFloat(
        newPriceContainer.textContent.replace(/[^0-9.]/g, "")
      ) || 0;

      // Recalculate total
      updateTotal();
    }
  });
});
